<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />

        <search-form key="claimsSearch1"
                     :inputs="searchInputsEx"
                     class="mb-5"
                     @clear="handleClearClick"
                     @search="handleSearchClick" />
        <hr />

        <div>
            <b-dropdown size="lg" id="claimActions" text="Actions" class="m-md-2">
                <b-dropdown-item @click="handleExportClick">
                    Export
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item :disabled="!(selectedItems && selectedItems.length > 0)"
                                 @click="handleTaskClick">
                    Mark As
                </b-dropdown-item>
            </b-dropdown>
        </div>

        <hr />
        <transition name="fade">
            <select-task v-if="showFlag && (selectedItems && selectedItems.length > 0)"
                         :tasks="taskOptions"
                         :button_text="`Set (${selectedItems.length} records)`"
                         class="mb-2 border-bottom"
                         @button-click="handleUpdateFlagsClick" />
        </transition>

        <transition name="fade">
            <data-list-csv v-if="showExport"
                           class="mb-2 border-bottom"
                           :dataCols="claimsColsOverride"
                           :dataListItems="claimsList"
                           :selectedItems="selectedItems">
            </data-list-csv>

        </transition>

        <hr />
        <div class="row">
            <div class="col">
                <page-size v-model="pageSize"
                           @input="handlePageSizeChange" />
            </div>
            <div class="col">
                <order-by v-model="selectedOrderBy"
                          :options="orderByOptionsOverride"
                          @goClick="handleOrderByClick" />
            </div>
        </div>



        <!--<data-list :dataCols="claimsColsOverride"
               :dataListItems="claimsList"
               :tableClass="'table table-striped table-sm'"
               :showCheckbox="true"
               @change="handleSelectedItemsChange"
               @dbl-click="handleItemDblClick" />

    <b-pagination align="center"
                  size="md"
                  :total-rows="totalRecords"
                  v-model="pageNumber"
                  :per-page="pageSize"
                  @input="handlePagenationInput" />-->

        <data-list-pagination :dataCols="claimsColsOverride"
                              :dataListItems="claimsList"
                              :showCheckbox="true"
                              :tableClass="'table table-striped table-sm'"
                              :totalRecords="totalRecords"
                              :pageNumber="pageNumber"
                              :pageSize="pageSize"
                              @change="handleSelectedItemsChange"
                              @dbl-click="handleItemDblClick"
                              @pagination-input="handlePagenationInput" />

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>

<script>

import claimsSearch from '@/mixins/claimsSearch.js'

import PageHeader from '@/components/PageHeader.vue'
//import DataList from '@/components/DataList.vue'
import DataListPagination from "@/components/DataListPagination.vue";
import DataListCSV from '@/components/DataListCSV.vue'
//import SelectStatus from '@/components/SelectStatus.vue'
import SelectTask from '@/components/SelectTask.vue'
import PageSize from '@/components/PageSize.vue'
import OrderBy from '@/components/OrderBy.vue'
import SearchForm from '@/components/SearchForm.vue'
import { searchInputs } from '@/ui.config/inputs/claimsBucket4SearchInputs'
import { claimsCols1, claimsCols2 } from '@/ui.config/cols/claimsBucket4ClaimsCols'

//import { mapActions } from 'vuex'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

 let indexOfObject = function (array, prop, value) {
    for (var i = 0; i < array.length; i += 1) {
        if (array[i][prop] === value) {
            return i;
        }
    }
    return -1;
}
//  RepairOptions
export default {
    name:'ClaimsBucket4',
    props: ['ignoreTaskFlags'],
    mixins: [
        claimsSearch,
    ],
    components: {
        PageHeader,
        'data-list-pagination': DataListPagination,
        //DataList,
        'data-list-csv': DataListCSV,
        //'select-status': SelectStatus,
        'select-task': SelectTask,
        PageSize,
        OrderBy,
        SearchForm,
        Loading
    },
    data: () => {
        return {
            pageHeader: {
                title: 'Selected Repair Options',
            },
            searchInputs: searchInputs,

            insuranceLineTypes: [
                {
                    id: 1,
                    label: 'GADGET'
                },
                {
                    id: 2,
                    label: 'TIGA'
                },
                {
                    id: 5,
                    label: 'POLICE FED'
                }
            ]

            //taskOptions: [
            //    { text: 'Updated EVO with selected repair option details', value: '1003' },
            //    { text: 'Updated EVO with cancelled repair option details', value: '1004' }
            //],
        }
    },
    beforeMount() {
        this.fetchRepairProviders()
        this.fetchRepairOptionTypes()
        //this.claimsSearch(null, 1)
        this.fetchUnderwriters()
        },
        mounted() {
            this.clearClaimsList()
        },
        computed: {
        searchInputsEx() {
            var { repairProviders, repairOptionTypes, insuranceLineTypes, underwriters } = this

            if (searchInputs && searchInputs.length > 0) {

                if (repairProviders) {
                    let repairProvidersIndex = indexOfObject(searchInputs, 'id', 'provider')
                    if (repairProvidersIndex > -1) {
                        searchInputs[repairProvidersIndex].options = repairProviders
                    }
                }

                if (repairOptionTypes) {
                    let repairOptionTypesIndex = indexOfObject(searchInputs, 'id', 'optionType')
                    if (repairOptionTypesIndex > -1) {
                        searchInputs[repairOptionTypesIndex].options = repairOptionTypes
                    }
                }

                if (insuranceLineTypes) {
                    let insuranceLineIndex = indexOfObject(searchInputs, 'id', 'insuranceLine')
                    if (insuranceLineIndex > -1) {
                        searchInputs[insuranceLineIndex].options = insuranceLineTypes
                    }
                }

                if (underwriters) {
                    let underwritersIndex = indexOfObject(searchInputs, 'id', 'underwriter')
                    searchInputs[underwritersIndex].options = underwriters
                }
            }

            return searchInputs
        },
        claimsColsOverride() {
            if ((this.includeCancelled && this.includeCancelled == true) ||
                (this.onlyCancelled && this.onlyCancelled == true)) {
                return claimsCols1
            }

            return claimsCols2
        },
        orderByOptionsOverride() {
            if ((this.includeCancelled && this.includeCancelled == true) ||
                (this.onlyCancelled && this.onlyCancelled == true)) {
                return [
                    {
                        id: 0,
                        key: 'DateCreated',
                        label: 'Selected Date'
                    },
                    {
                        id: 1,
                        key: 'DateCancelled',
                        label: 'Cancelled Date'
                    },
                    {
                        id: 2,
                        key: 'ClaimReference',
                        label: 'Claim Reference'
                    }
                ]
            }

            return [
                {
                    id: 0,
                    key: 'SelectedDate',
                    label: 'Selected Date'
                }               
            ]
        },
        taskOptions() {
            if (this.includeCancelled == false) {
                return [
                    { text: 'Updated EVO with selected repair option details', value: '1003' }
                ]
            }

            if (this.onlyCancelled == true) {
                return [
                    { text: 'Updated EVO with cancelled repair option details', value: '1004' }
                ]
            }
            return [
                { text: 'Updated EVO with selected repair option details', value: '1003' },
                { text: 'Updated EVO with cancelled repair option details', value: '1004' }
            ]
        }
    },
    methods: {
        // Override mixin
        buildSearchValues(payload) {
            if (payload != null) {
                let { claimReference, relatedReference, provider, optionType, imei, serial, insuranceLine, underwriter } = payload

                let criteria = {
                    claimReference,
                    relatedReference,
                    imei,
                    serial,
                    providerId: provider ? provider.id : null,
                    repairOptionTypeId: optionType ? optionType.id : null,
                    insuranceLineId: insuranceLine ? insuranceLine.id : null,
                    underwriterId: underwriter ? underwriter.id : null,
                }

                return criteria
            } else {
                return null
            }
        },
        // Override mixin
        buildSearchCriteria(searchValues, pageNumber) {
            let ordering = {
                orderBy: this.orderBy,
                sortDirection: this.sortDirection
            }

            let pages = {
                pageSize: this.pageSize,
                pageNumber: pageNumber
            }

            let criteria = {
                ...searchValues,
                noRelatedReference: this.noRelatedReference, // hide if in EVO
                //includeCancelled: this.includeCancelled,
                onlyCancelled: this.onlyCancelled,
                ignoreTaskFlags: this.ignoreTaskFlags,                
                ...ordering,
                ...pages
            }

            return criteria
        },
        // Override mixin
        claimsSearch(searchValues, pageNumber) {
            this.clearClaimsList()

            let criteria = this.buildSearchCriteria(searchValues, pageNumber)
            this.fetchClaimsSelectedRepairOptionsFilterPagenated(criteria)
        },
        handleUpdateFlagsClick(evPayload) {
            let selected = evPayload

            let { selectedItems } = this
            let criteria = this.buildSearchCriteria(this.buildSearchValues(this.searchPayload))
            this.selectedItems = []
            this.selected = null
            this.showFlag = false

            this.updateClaimsRepTaskFlags(
                {
                    claimSearchCriteria: criteria,
                    claims: selectedItems.map(i => {
                        return {
                            claimId: i.claimId,
                            rowVersion: i.claimRowVersion
                        }
                    }),
                    taskFlags: selected
                }
            )
        },
    }
}
</script>

<style>

</style>
